import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=758b55cc&scoped=true&"
import script from "./Chip.vue?vue&type=script&lang=ts&"
export * from "./Chip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b55cc",
  null
  
)

export default component.exports